import * as React from 'react';
import { ethers } from "ethers";
import './calculator.scss'
import CustomizedSlider from './Slider';
import routerAbi from '../../abi/router.json';
import tokenAbi from '../../abi/token.json';
import {provider, setProvider, signer, setSigner} from '../../App';
import values from "../../values.json"


const Calculator = () => {

  const [tokenAmount, setTokenAmount] = React.useState(0);
  const [apy, setApy] = React.useState(388047);
  let [price, setPrice] = React.useState(0.50);
  let [balance, setBalance] = React.useState(0);
  const [previousPrice, setPreviousPrice] = React.useState(0);
  const [futurePrice, setFuturePrice] = React.useState(0);
  const [days, setDays] = React.useState(20);
  
  let finalTokens = 0;

  let _provider = React.useContext (provider);
  let _setProvider = React.useContext (setProvider);
  let _signer = React.useContext (signer);
  let _setSigner = React.useContext (setSigner);


  React.useEffect(() => {
    try{
      getPrice()
      _getBalance()
    } catch (error){
      console.log(error);
    }
  }, []);

  function handleChange(event) {
    const { name, value } = event.target;
    if (name === "tokenAmount") setTokenAmount(value);
    else if (name === "apy") setApy(value);
    else if (name === "previousPrice") setPreviousPrice(value);
    else if (name === "futurePrice") setFuturePrice(value);
  }

  finalTokens = ((1.0001058)** (6*24*days))* tokenAmount;

  async function getPrice(){
    try{
      let rpcUrl = values.rpcUrl;
      let provider_ = new ethers.providers.JsonRpcProvider(rpcUrl);
      let router = new ethers.Contract(
        values.router,
        routerAbi,
        provider_
      );
      const tokenIn = values.token;
      const tokenOut = values.wbnb;
      
      const amountIn = ethers.utils.parseUnits("1", 5);
      let amounts = await router.getAmountsOut(amountIn, [tokenIn, tokenOut]);
      let busd = values.busd;
      let amounts2 = await router.getAmountsOut(amounts[1], [tokenOut, busd]);
      console.log(`
          tokenIn: ${ethers.utils.formatEther(amountIn.toString())} ${tokenIn} (cosmik)
          tokenOut: ${ethers.utils.formatEther(amounts2[1].toString())} ${busd} (BUSD)
        `);
      setPrice(parseFloat(ethers.utils.formatEther(amounts2[1].toString())).toFixed(8));
    } catch (err) {
      console.log (err);
    }
  }

  async function _getBalance (address){
    try {
      let rpcUrl = values.rpcUrl;
      let provider_ = new ethers.providers.JsonRpcProvider(rpcUrl);
      let token = new ethers.Contract(
        address,
        tokenAbi,
        provider_
      );
      let provider = new ethers.providers.Web3Provider(window.ethereum);
      let signer = provider.getSigner();
      const walletAddress = await signer.getAddress();
      let balance = await token.balanceOf (walletAddress);
      let decimals = await token.decimals();
      decimals = parseInt(decimals.toString());
      balance = ethers.utils.formatUnits(balance, decimals);
      console.log ("balance", balance.toString());
      return parseFloat(balance.toString()).toFixed(2);
    } catch (err){
      console.log (err, address);
      return 0;
    }
  }

  return (
    <div className='dash calculator'>
        <div className='container'>
            <div className="block_calculator">
      <div className='inner_block_calculator'>
      <div className='dashboard-card'>
            <div className='card_title'>
            <h2>Current Price</h2>
            </div>
            <div className="card_value card_value_acc">
             <h2>${parseFloat(price).toFixed(2)}</h2>
            </div>
          </div>
      </div>

     
        <div className='inner_block_calculator'>
        <div className='dashboard-card'>
            <div className='card_title'>
            <h2>Your Balance</h2>
            </div>
            <div className="card_value card_value_acc">
             <h2>{balance}</h2>
            </div>
          </div>
      </div>

      </div>               
    </div>

{/* input block */}


    <div className='outer_input'>
        <div className='input_inner'>
            <div className='title_input'>
                <h2 className='input_title'>Token Amount</h2>
            </div>
            <div className='inputbox'>
            <input placeholder='0' className='input_main' name= "tokenAmount" onChange={handleChange} value={tokenAmount} />
            </div>
        </div>

        <div className='input_inner'>
            <div className='title_input'>
                <h2 className='input_title'>APY (%)</h2>
            </div>
            <div className='inputbox'>
            <input placeholder='0' className='input_main' name= "apy" onChange={handleChange} value={apy} />
            </div>
        </div>

        <div className='input_inner'>
            <div className='title_input'>
                <h2 className='input_title'>Price at purchase ($)</h2>
            </div>
            <div className='inputbox'>
            <input placeholder='0' className='input_main' name= "previousPrice" onChange={handleChange} value={previousPrice} />
            </div>
        </div>

        <div className='input_inner'>
            <div className='title_input'>
                <h2 className='input_title'>Future market price ($)</h2>
            </div>
            <div className='inputbox'>
            <input placeholder='0' className='input_main' name= "futurePrice" onChange={handleChange} value={futurePrice} />
            </div>
        </div>



{/* last block */}


    </div>

<div className='slider'>
<CustomizedSlider days= {days} setDays= {setDays} />
</div>

<div className='block4 info_calculator'>
          <div className="row">
            <div className='title_card'>
                <h2>Your initial investment</h2>
            </div>

            <div className='value value_calculator'>
            <h2>${tokenAmount* previousPrice}</h2>
            </div>
          </div>

          <div className="row">
            <div className='title_card'>
            <h2>Current wealth</h2>
            </div>

            <div className='value value_calculator '>
            <h2>${tokenAmount* previousPrice}</h2>
            </div>
          </div>



          <div className="row">
            <div className='title_card'>
                <h2>Token rewards estimation</h2>
            </div>

            <div className='value value_calculator'>
            <h2>{(finalTokens- tokenAmount).toFixed(3)} Token</h2>
            </div>
          </div>



          <div className="row">
            <div className='title_card'>
            <h2>Potential return</h2>
            </div>

            <div className='value value_calculator'>
            <h2>${(finalTokens* futurePrice).toFixed(3)}</h2>
            </div>
          </div>



          <div className="row">
            <div className='title_card'>
        <h2>ROI(1-Day Rate) %</h2>
            </div>

            <div className='value value_calculator'>
            <h2>2.286%</h2>
            </div>
          </div>






      </div>
    </div>
  )
}

export default Calculator